import { getSavedLang, messages } from "@/i18n";

const COOKIE_ERROR_RULES = [
  {
    key: "cookie_err_client_id_not_found",
    match: (message) =>
      message.includes("client id not found in auth_user cookie") ||
      message === "client id not found.",
  },
  {
    key: "cookie_err_auth_user_missing",
    match: (message) => message.includes("auth_user cookie missing"),
  },
  {
    key: "cookie_err_auth_user_parse_failed",
    match: (message) => message.includes("failed to parse auth_user cookie"),
  },
  {
    key: "cookie_err_consultant_id_not_found",
    match: (message) =>
      message.includes("consultant id not found in auth_user cookie") ||
      message.includes("consultant id not found"),
  },
  {
    key: "cookie_err_office_id_not_found",
    match: (message) => message.includes("office id not found"),
  },
  {
    key: "cookie_err_auth_token_missing",
    match: (message) =>
      (message.includes("auth_token") || message.includes("auth token")) &&
      message.includes("missing"),
  },
  {
    key: "cookie_err_user_data_not_found",
    match: (message) => message.includes("no user data found in cookies"),
  },
];

function resolveTranslator(tOrLang) {
  if (typeof tOrLang === "function") return tOrLang;

  const lang =
    typeof tOrLang === "string" ? tOrLang : getSavedLang();

  return (key) => messages[lang]?.[key] || key;
}

/** Translate known cookie/session error strings for toast display. */
export function translateCookieToastMessage(message, tOrLang) {
  if (message == null) return message;

  const raw = String(message).trim();
  if (!raw) return raw;

  const normalized = raw.toLowerCase();
  const t = resolveTranslator(tOrLang);

  for (const rule of COOKIE_ERROR_RULES) {
    if (rule.match(normalized)) {
      return t(rule.key);
    }
  }

  return raw;
}
